
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { formatDateWithoutTime } from "@/app/infrastructures/misc/Utils";
import { ClaimDetailData } from "@/domain/entities/Claim";

class Props {
  detailData = prop<ClaimDetailData>({
    default: () => new ClaimDetailData(),
    type: Object
  });
}

@Options({
  components: {
    Title
  }
})
class SectionDeliveryDetail extends Vue.with(Props) {
  props: any = this.$props;
  get createdAt() {
    return `${formatDateWithoutTime(
      this.props.detailData.sttCreatedAt,
      false
    )}`;
  }

  get updatedAt() {
    return `${formatDateWithoutTime(
      this.props.detailData.sttUpdatedAt,
      false
    )}`;
  }
}
export default SectionDeliveryDetail;
